import { Injectable } from '@angular/core';

import { DialogService } from '@mode/shared/ui';
import { EmailFailureDialogComponent, EmailFailureDialogData } from './email-failure-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class EmailFailureDialogService {
  private readonly _id = 'mode-email-failure-dialog';

  constructor(private dialogService: DialogService) {}

  open({ failures }: EmailFailureDialogData) {
    const emailFailureDialogRef = this.dialogService.open({
      component: EmailFailureDialogComponent,
      matDialogConfig: {
        id: this._id,
        data: {
          failures,
        },
      },
    });

    return emailFailureDialogRef.afterClosed();
  }
}
